import cn from 'classnames';

import styles from './RegistrySourcesCard.module.scss';

import type { RegistrySource, RegistrySourcesCardProps } from './RegistrySourcesCard.types';

const Row = ({ item, hidden }: { item: RegistrySource; hidden?: boolean }) => (
  <div className={styles.row} aria-hidden={hidden || undefined}>
    <span className={styles.flag}>{item.flag}</span>

    <span className={styles.rowBody}>
      <span className={styles.registry}>{item.registry}</span>
      <span className={styles.country}>{item.country}</span>
    </span>

    <span className={styles.connected}>
      <span className={styles.connectedDot} />
      Connected
    </span>
  </div>
);

export const RegistrySourcesCard = ({
  items,
  label = 'Government sources',
  liveLabel = 'Live',
  className,
}: RegistrySourcesCardProps) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.head}>
      <span className={styles.label}>{label}</span>
      <span className={styles.live}>
        <span className={styles.dot} aria-hidden="true" />
        {liveLabel}
      </span>
    </div>

    <div className={styles.viewport}>
      <div className={styles.track}>
        {items.map((item) => (
          <Row key={item.registry} item={item} />
        ))}
        {items.map((item) => (
          <Row key={`${item.registry}-repeat`} item={item} hidden />
        ))}
      </div>
    </div>
  </div>
);
